import { render } from "./confirm-unpublish.vue?vue&type=template&id=82355506&lang=pug"
import script from "./confirm-unpublish.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-unpublish.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__